import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import Navbar from '../../components/navbar/Navbar';
import Footer from '../../components/footer/Footer';
import LoginForm from './components/loginForm/LoginForm';

ReactDOM.render(
  <Provider store={store}>
    <div>
      <Navbar />
      <div className="container is-fluid">
        <section>
          <div className="columns">
            <div className="column is-three-quarters">
              <h1>Competas Global Limited</h1>
              <h1>WELCOME TO YOUR COMPETAS TECHNICAL ASSESSMENT</h1>
              <br />
              <p>
                Please note that the assessment process will take 2 to 3 hours.
                The assessment is taken during one session and there will be no
                breaks (other than comfort ones) during this time. The
                assessment will be conducted under strict requirements.
              </p>
              <p>
                During the assessment you will be asked a number of questions on
                each topic based on your self-assessed levels. Depending on the
                number of correct answers, the difficulty of questions will
                adjust accordingly, allowing Competas to evaluate your actual
                competency level for each topic.
              </p>
              <p>
                Following your assessment, your results will be made available
                to you after two working days via the Competas candidate
                dashboard (
                <a href={process.env.PORTAL_URL}>{process.env.PORTAL_URL}</a>
                ). Your results will automatically be sent to your sponsor.
              </p>
            </div>
            <LoginForm />
          </div>
        </section>
      </div>
      <Footer isLogin={true} />
    </div>
  </Provider>,
  document.getElementById('app'),
);



// WEBPACK FOOTER //
// ./src/pages/login/index.jsx